import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: null, userCheckLoading: false };

const isLoginSlice = createSlice({
    name: "isLogin",
    initialState,
    reducers: {
        loginTrue(state) {
            state.value = true;
        },
        loginFalse(state) {
            state.value = false;
        },
        setUserCheckLoading(state, action) {
            state.userCheckLoading = action.payload;
        },
    },
});

export const { loginTrue, loginFalse, setUserCheckLoading } =
    isLoginSlice.actions;
export default isLoginSlice.reducer;
